import React, { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { CommonTarget } from './common-targeting';

export const Topics = ({ topicIds }: { topicIds: number[] }) => {
  const i18n = useContext(I18nContext);

  return (
    <CommonTarget label={_TL_('Topics')} includedData={topicIds} pluralText={i18n.getString(_TL_('topics'))} singularText={i18n.getString(_TL_('topic'))} />
  );
};
